"use strict";
/**
 * @module Services.Metrics
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link ServerMetrics}
 */
var ServerMetricsSerialiserClass = /** @class */ (function (_super) {
    __extends(ServerMetricsSerialiserClass, _super);
    function ServerMetricsSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link ServerMetrics} from the stream
     *
     * @param bis  the input stream
     * @return     the instance that was read
     */
    ServerMetricsSerialiserClass.prototype.read = function (bis) {
        return Codec.readDictionary(bis, function (i) { return Codec.readDictionary(i, Codec.readInt64); });
    };
    /**
     * Write a {@link ServerMetrics} to the stream
     *
     * @param bos    the output stream
     * @param value  the instance to be written
     */
    ServerMetricsSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeDictionary(bos, value, function (o, v) { return Codec.writeDictionary(o, v, Codec.writeInt64); });
    };
    return ServerMetricsSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ServerMetricsSerialiserClass = ServerMetricsSerialiserClass;
/**
 * The singleton
 */ // tslint:disable-next-line:variable-name
exports.ServerMetricsSerialiser = new ServerMetricsSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metrics/server-metrics-serialiser.js
// module id = 1276
// module chunks = 1